import request from '../utils/request'

/**
 * API Key相关API
 */

// 获取API Key列表
export function getApiKeyList(params) {
  return request({
    url: '/apikey',
    method: 'get',
    params
  })
}

// 获取API Key统计信息
export function getApiKeyStatsSummary() {
  return request({
    url: '/apikey/stats',
    method: 'get'
  })
}

// 创建API Key
export function createApiKey(data) {
  return request({
    url: '/apikey',
    method: 'post',
    data
  })
}

// 吊销（禁用）API Key
export function revokeApiKey(id) {
  return request({
    url: `/apikey/${id}`,
    method: 'delete'
  })
}

// 永久删除API Key
export function deleteApiKey(id) {
  return request({
    url: `/apikey/${id}/delete`,
    method: 'delete'
  })
}

// 获取API Key调用日志
export function getApiKeyLogs(id, params) {
  return request({
    url: `/apikey/${id}/logs`,
    method: 'get',
    params
  })
}

// 获取API Key调用统计
export function getApiKeyStats(id, params) {
  return request({
    url: `/apikey/${id}/stats`,
    method: 'get',
    params
  })
}

export default {
  getApiKeyList,
  getApiKeyStatsSummary,
  createApiKey,
  revokeApiKey,
  deleteApiKey,
  getApiKeyLogs,
  getApiKeyStats
}
